import React from 'react'
import {connect} from 'react-redux'
// noinspection NpmUsedModulesInstalled
import {
    CreditCardOutlined,
    EditOutlined,
    EyeOutlined,
    HomeOutlined,
    LogoutOutlined,
    PlusOutlined,
    QuestionOutlined,
    SolutionOutlined,
    UserOutlined
} from '@ant-design/icons'
import {Avatar, Badge, Breadcrumb, Button, Divider, Image, Layout, List, Popover, Select, Tooltip} from 'antd'
import {withRouter} from 'react-router'
import {getUser} from '../api/user'
import {getAllArtistNames} from '../api/artistNames'

import {menuFoldOut, menuUnfoldOut} from '../action/style'
import {switchArtist, userLogout, userUpdatePlan} from '../action/user'
import {DEFAULT} from '../app/constant'
import '../asset/less/App.css'
import '../asset/less/NotificationCenter.css'
import HttpError from './base/HttpError'
import {
    URL_ACCOUNT_INFO,
    URL_BILLING,
    URL_BULK_UPLOAD,
    URL_HOME,
    URL_LOGIN,
    URL_NEW_COLLECTIONS,
    URL_NEW_CONTACT_PEOPLE,
    URL_NEW_PIECES,
    URL_PROFILE_INFO
} from '../const'
import {getArtist, getArtistPermissions, getArtistProfile} from '../api/artists'
import {getArtistShowcaseUrl} from './Utils'
import {artistNamesSave} from "../action/artist";
import axios from "axios";
import NotificationPanel from "./NotificationPanel";
import MyBreadcrumb from "./MyBreadcrumb";
import {is_admin_user} from "../app/role";

const {Header} = Layout

@connect(
    (state) => ({
        siderCollapsed: state.style.siderCollapsed,
        siderWidth: state.style.siderWidth,
        id: state.user.info.id, // login user Id
        token: state.user.info.token, // login user token
        artistId: state.user.info.artistId, //artist obj id
        userId: state.user.info.userId, // artist user Id
        email: state.user.info.email, // login user email
        admin_email: state.user.info.admin_email, // admin user email
        role: state.user.info.role, // staff, admin or artist
        artistName: state.user.info.artistName
    }),
    {
        menuFoldOut,
        menuUnfoldOut,
        userLogout,
        switchArtist,
        artistNamesSave,
        userUpdatePlan
    }
)
class SAMHeader extends React.Component {
    constructor(props) {
        super(props)
        this.state = {
            artists: [],
            artistPermissions: [],
            curArtist: props.artistId == null ? DEFAULT : props.artistId,
            loading: false,
            artistAvatar: null,
            plan: '',
            trialDays: 0,
        }
        this.CancelToken = axios.CancelToken.source()
    }

    isTrial = () => {
        return this.state.plan === 'trial'
    }

    componentDidMount() {
        function getDays(end) {
            try {
                let expireDate = new Date(end);
                const startDate = new Date();

                // Calculate the difference in milliseconds
                const timeDifference = expireDate.getTime() - startDate.getTime();

                // Convert milliseconds to days
                return Math.floor(timeDifference / (1000 * 60 * 60 * 24))
            } catch (e) {
                return 0
            }
        }

        function isExpired(plan, start, end) {
            let days = Math.max(0, getDays(end))
            return days === 0
        }

        if(this.props.role === 'admin') {
            this.props.userUpdatePlan({
                type: 'unlimited',
                expired: false
            })
        }

        if (this.props.userId && this.props.artistId) {
            getUser(this.props.userId, this.CancelToken)
                .then((response) => {
                    const userInfo = response.data
                    this.setState({
                        userName: userInfo.first_name + ' ' + userInfo.last_name
                    })
                })
                .catch((error) => {
                    if (axios.isCancel(error)) {
                        return
                    }
                    HttpError(error)
                })

            getArtist(this.props.userId, this.CancelToken)
                .then(async (response) => {
                    const artist = response.data
                    this.setState({
                        plan: artist.sam_plan,
                        trialDays: Math.max(0, 14 - getDays(artist.sam_plan_start_at)),
                        expired: isExpired(artist.sam_plan, artist.sam_plan_start_at, artist.sam_plan_expire_at)
                    })
                    const artistProfile = (await getArtistProfile(artist.id)).data
                    this.setState({
                        artistAvatar: artistProfile.avatar
                    })
                    this.props.userUpdatePlan({
                        type: artist.sam_plan,
                        expired: isExpired(artist.sam_plan, artist.sam_plan_start_at, artist.sam_plan_expire_at),
                        plan_start: artist.sam_plan_start_at,
                        plan_end: artist.sam_plan_expire_at
                    })
                })
                .catch((error) => {
                    if (axios.isCancel(error)) {
                        return
                    }
                    this.setState({
                        artistAvatar: null
                    })
                })
        }

        if (is_admin_user(this.props)) {
            getAllArtistNames(1, 10000, this.CancelToken)
                .then((response) => {
                    this.setState({
                        artists: response.data
                    })
                    this.props.artistNamesSave(response.data)
                })
                .catch((error) => {
                    if (axios.isCancel(error)) {
                        return
                    }
                    HttpError(error)
                })

            getArtistPermissions(1, 10000, this.CancelToken).then((response) => {
                this.setState({
                    artistPermissions: response.data.results
                })
            }).catch((error) => {
                if (axios.isCancel(error)) {
                    return
                }
                HttpError(error)
            })
        }
    }

    componentWillUnmount() {
        this.CancelToken.cancel("cancel")
    }

    logout = () => {
        this.props.userLogout()
        this.props.history.replace({pathname: URL_LOGIN})
    }

    sleep = async (time) => {
        return new Promise((r) => setTimeout(r, time))
    }

    changeCurrProfile = (e) => {
        const updateTimeout = '300' // 300ms
        if (e === this.props.artistId) return
        if (e === DEFAULT) {
            this.props.switchArtist({
                id: this.props.id, // login user Id
                token: this.props.token, // login user token
                artistId: null, //artist obj id
                userId: null, // artist user Id
                email: this.props.admin_email, // login user email
                admin_email: this.props.admin_email, // admin user email
                role: this.props.role, // staff, admin or artists
                artistName: this.props.artistName
            })
            this.setState(
                {
                    curArtist: DEFAULT
                },
                () => {
                    setTimeout(() => {
                        window.location.reload()
                    }, updateTimeout)
                }
            )
        }
        const target_artists = this.state.artists.filter((v) => {
            return v.artist_id === e
        })
        if (target_artists.length === 0) return
        this.props.switchArtist({
            id: this.props.id, // login user Id
            token: this.props.token, // login user token
            artistId: target_artists[0].artist_id, //artist obj id
            userId: target_artists[0].user_id, // artist user Id
            email: target_artists[0].email, // login user email
            role: this.props.role, // staff, admin or artists
            admin_email: this.props.admin_email, // admin user email
            artistName: target_artists[0].name
        })
        this.setState(
            {
                curArtist: target_artists[0].artist_id
            },
            () => {
                setTimeout(() => {
                    window.location.reload()
                }, updateTimeout)
            }
        )
    }

    doAdmin = (e) => {
        if (e === 'Logout') {
            this.logout()
        }
    }

    userActionList = () => {
        const url = getArtistShowcaseUrl(this.props.artistId, this.state.userName)
        const data = [
            <Tooltip key={0} title={this.props.email}>
                <Button
                    type={'text'}
                    onClick={() => {
                        window.open(url, '_blank')
                    }}
                    style={{marginBottom: 0}}
                    icon={<EyeOutlined/>}
                >
                    <span>{this.state.userName}</span>
                </Button>
            </Tooltip>,
            <Button
                key={1}
                type={'text'}
                onClick={() => {
                    this.props.history.push(URL_ACCOUNT_INFO)
                }}
                style={{marginBottom: 0}}
                icon={<EditOutlined/>}
            >
                <span>My Account</span>
            </Button>,
            <Button
                key={2}
                type={'text'}
                onClick={() => {
                    this.props.history.push(URL_PROFILE_INFO)
                }}
                style={{marginBottom: 0}}
                icon={<SolutionOutlined/>}
            >
                <span>My Profile</span>
            </Button>,
            <Button
                key={2}
                type={'text'}
                onClick={() => {
                    this.props.history.push(URL_BILLING)
                }}
                style={{marginBottom: 0}}
                icon={<CreditCardOutlined/>}
            >
                <span>My Billing</span>
            </Button>,
            <Button
                key={3}
                style={{marginBottom: 0}}
                type={'text'}
                onClick={() => {
                    this.doAdmin('Logout')
                }}
                icon={<LogoutOutlined/>}
            >
                <span>Log Out</span>
            </Button>
        ]
        return <List bordered dataSource={data}
                     renderItem={(item, index) => <List.Item key={index}>{item}</List.Item>}/>
    }

    addActionList = () => {
        const data = ['Pieces', 'Bulk Upload', 'Collections', 'Contacts']
        const href = [URL_NEW_PIECES, URL_BULK_UPLOAD, URL_NEW_COLLECTIONS, URL_NEW_CONTACT_PEOPLE]
        return (
            <List
                bordered
                dataSource={data}
                renderItem={(item, index) => (
                    <List.Item key={index}>
                        <a href={href[index]}>{item}</a>
                    </List.Item>
                )}
            />
        )
    }

    render() {
        let getHeaders = () => {
            const paths = this.props.location.pathname.split('/')
            const layout = []
            let url = ''
            let prefix = '/sam'
            const pathMap = {
                apply_for_revart: 'application'
            }
            const getFromMap = (path) => {
                if (pathMap[path]) {
                    return pathMap[path]
                } else {
                    return path
                }
            }
            paths.forEach((path, index) => {
                if (path === '') return
                if (path === 'sam') {
                    layout.push(
                        <Breadcrumb.Item key={index}>
                            <a href={URL_HOME} style={{textTransform: 'capitalize'}}>
                                <HomeOutlined/> {path}
                            </a>
                        </Breadcrumb.Item>
                    )
                } else {
                    url += '/' + path
                    if (path === 'edit') return;
                    layout.push(
                        <Breadcrumb.Item key={index}>
                            <a href={prefix + url + '/'} style={{textTransform: 'capitalize'}}>
                                {getFromMap(path)}
                            </a>
                        </Breadcrumb.Item>
                    )
                }
            })
            return (
                <>
                    <MyBreadcrumb {...this.props}>{layout}</MyBreadcrumb>
                </>
            )
        }

        let getAvatar = () => {
            if (this.state.artistAvatar) {
                return (
                    <Avatar
                        src={
                            <Image
                                preview={false}
                                src={this.state.artistAvatar}
                                style={{
                                    width: 36,
                                    cursor: 'pointer'
                                }}
                            />
                        }
                    />
                )
            } else {
                return (
                    <Avatar
                        style={{
                            cursor: 'pointer'
                        }}
                        icon={<UserOutlined/>}
                    ></Avatar>
                )
            }
        }

        let getAdminArtistOption = (artist) => {
            const id = artist.artist_id
            const filter_permission = this.state.artistPermissions.filter((permission) => {
                return permission.artist.toString() === id
            })
            if (filter_permission.length > 0) {
                const permission = filter_permission[0]
                if (permission.is_pending_approve) {
                    return artist.artist_id + ' ' + artist.name + ' [pending]'
                }
                let suffix = ''
                if (permission.is_approved) {
                    suffix += ' [approved]'
                }
                if (permission.is_display) {
                    suffix += ' [display]'
                }
                return artist.artist_id + ' ' + artist.name + suffix
            }
            return artist.artist_id + ' ' + artist.name
        }

        return (
            <>
                <Header
                    ghost={'false'}
                    style={{
                        zIndex: 1,
                        width: '100%',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'space-between',
                        borderBottom: '1px solid rgba(0,0,0,0.15)'
                    }}
                >
                    {getHeaders()}

                    {is_admin_user(this.props) ? (
                        <Select
                            showSearch
                            style={{width: '30%', marginRight: 12, cursor: 'pointer'}}
                            placeholder='Select Artist'
                            optionFilterProp='children'
                            value={this.state.curArtist}
                            onChange={this.changeCurrProfile}
                        >
                            <Select.Option key='default' value={DEFAULT}>
                                Default
                            </Select.Option>
                            {this.state.artists.map((artist) => (
                                <Select.Option key={artist.artist_id} value={artist.artist_id}>
                                    {getAdminArtistOption(artist)}
                                </Select.Option>
                            ))}
                        </Select>
                    ) : (
                        ''
                    )}

                    <div
                        style={{
                            display: 'flex',
                            flexDirection: 'row',
                            gap: 1,
                            alignItems: 'center',
                            marginRight: 6
                        }}
                    >
                        <div style={{
                            display: 'flex',
                            flexDirection: 'row',
                            gap: 1,
                            alignItems: 'center',
                            marginBottom: 6
                        }}>
                            <Popover placement='bottomRight' title='' content={this.addActionList} trigger='click'>
                                <Button style={{display: 'block', marginRight: 12, marginTop: 12}}
                                        icon={<PlusOutlined/>}/>
                            </Popover>

                            <Button
                                style={{display: 'block', marginRight: 12, marginTop: 12}}
                                icon={<QuestionOutlined/>}
                                onClick={() => {
                                    window.open('https://revart.co/sam/faq/docs/doc-main', '__blank')
                                }}
                            />
                        </div>

                        <NotificationPanel userId={this.props.userId}/>
                        <Divider type={'vertical'}/>


                        <Badge
                            size='middle'
                            icon={<UserOutlined/>}
                            style={{
                                cursor: 'pointer'
                            }}
                        >
                            <Popover placement='bottomRight' title='' content={this.userActionList} trigger='hover'>
                                {getAvatar()}
                            </Popover>
                        </Badge>
                    </div>
                </Header>
                {this.isTrial() && !this.state.expired && (
                        <span style={{marginTop: 24, marginLeft: 'auto', marginRight: 24, paddingLeft: 12}}>You have
                        <span style={{color: 'red'}}> {this.state.trialDays}</span> days remaining on your trial.
                        &nbsp;<span style={{textDecoration: 'underline', cursor: 'pointer'}}
                                    onClick={() => {
                                        window.location.href = URL_BILLING + "#subscribe"
                                    }}>Subscribe</span></span>
                )}
            </>
        )
    }
}

export default withRouter(SAMHeader)
